<template>
  <div>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="CONSULTA EMPLEADO" key="1">
        <info-empleado @contractSelected="contractSelected"/>
        <seguimiento-incapacidades v-if="idEmp" :empleadoseleccionado="idEmp"/>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        idEmp: null
      }
    },
    methods: {
      contractSelected (idEmp) {
        this.idEmp = idEmp
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/MatrizSeguimiento/MatrizSeguimiento.vue